/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UsersFindAllResponse } from './UsersFindAllResponse';
import {
    UsersFindAllResponseFromJSON,
    UsersFindAllResponseFromJSONTyped,
    UsersFindAllResponseToJSON,
    UsersFindAllResponseToJSONTyped,
} from './UsersFindAllResponse';

/**
 * 
 * @export
 * @interface FindAllUsersV2200Response
 */
export interface FindAllUsersV2200Response {
    /**
     * 
     */
    data?: UsersFindAllResponse;
}

/**
 * Check if a given object implements the FindAllUsersV2200Response interface.
 */
export function instanceOfFindAllUsersV2200Response(value: object): value is FindAllUsersV2200Response {
    return true;
}

export function FindAllUsersV2200ResponseFromJSON(json: any): FindAllUsersV2200Response {
    return FindAllUsersV2200ResponseFromJSONTyped(json, false);
}

export function FindAllUsersV2200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllUsersV2200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : UsersFindAllResponseFromJSON(json['data']),
    };
}

export function FindAllUsersV2200ResponseToJSON(json: any): FindAllUsersV2200Response {
    return FindAllUsersV2200ResponseToJSONTyped(json, false);
}

export function FindAllUsersV2200ResponseToJSONTyped(value?: FindAllUsersV2200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': UsersFindAllResponseToJSON(value['data']),
    };
}

